import { useNavigate } from 'react-router-dom';
import { useFeuille } from '../partage/useArbre';
import { useGestesDeFeuille, useNavigationDeLaFeuille } from '../projets';
import { FicheDeLaFeuille } from './FicheDeLaFeuille';
import { useAllerALaFiche } from './useAllerALaFiche';

/**
 * La fiche d'une bulle posée dans un écran couché du téléphone, hors d'un projet (chantier
 * telephone-couche-suite, 03 et 04 : la Journée et l'Agenda couchés). C'est la fiche du
 * téléphone, branchée comme sur une feuille (`FicheDeLaFeuille`), en page (`enPage`) : ni voile,
 * ni croix, ni « ‹ la mère » ni sœurs. Elle lit la feuille de la bulle (sa bulle, son chemin, sa
 * couleur, le type et le papier du projet). Une autre bulle choisie, une autre fiche.
 *
 * Ce qui la quitterait (« C'est fait », Échap) la laisse posée : l'écran qui la porte la relit,
 * la bulle cochée s'y voit. Creuser, ou une étape, ouvrent leur feuille.
 */
export function FichePosee({ bulleId }: { bulleId: string }) {
  const naviguer = useNavigate();
  const feuille = useFeuille(bulleId);
  const gestes = useGestesDeFeuille();
  const navigation = useNavigationDeLaFeuille(bulleId);
  const allerALaFiche = useAllerALaFiche();
  if (!feuille.data || feuille.data.bulle.id !== bulleId) return <div className="fiche-posee-attente" aria-hidden="true" />;
  const { bulle, chemin, couleur, fiches, habit } = feuille.data;
  const resterLa = () => undefined;

  return (
    <FicheDeLaFeuille
      key={bulle.id}
      fiche={{ bulle, chemin }}
      centreId={bulle.id}
      couleur={couleur}
      fichesDuProjet={fiches}
      habitDuProjet={habit}
      gestes={gestes}
      navigation={navigation}
      allerALaFiche={allerALaFiche}
      onEntrer={(id) => naviguer(`/feuille/${id}`)}
      onRemonterApresSuppression={resterLa}
      enPage
      onFermerLaPage={resterLa}
    />
  );
}
